export const LETTER_SPACING = {
    NONE: 0,
};
